import * as Yup from 'yup';

export default Yup.object().shape({
    acceptConditions: Yup.boolean()
        .required('Нужно согласие на обработку персональных данных')
        .oneOf([true], 'Нужно согласие на обработку персональных данных')
});
